import * as React from 'react'
import * as st from './TabHeading.module.scss'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { HeadingBlock } from '../HeadingBlock/HeadingBlock'

export interface TabLink {
    active?: boolean
    attrs: BaseComponentProps & { href?: string }
    content: React.ReactChild
}
interface TabHeadingProps extends BaseComponentProps {
    tabLinks: Array<TabLink>
    swipeable?: boolean
}

export const TabHeading: React.ComponentType<TabHeadingProps> = props => (
    <TabHead {...props} />
)

export class TabHead extends React.Component<TabHeadingProps, {}> {

    displayName = 'TabHead'
    active = React.createRef<any>()

    constructor(props: TabHeadingProps) { super(props) }

    componentDidMount() {
        if (this.props.swipeable && (typeof this.active.current.scrollIntoView === 'function'))
            (this.active.current as HTMLElement).scrollIntoView({block: 'center', inline: 'center'})
    }

    render() {
        const { tabLinks, swipeable } = this.props
        return (
            <HeadingBlock swipable={swipeable}>
                {tabLinks.map((link, i) => {
                    const Comp = link.attrs.href ? 'a' : 'div'
                    const className = extractClassNamesFromProps(
                        link.attrs,
                        st.tab,
                        'dvui-tab',
                        {
                            [st.active]: link.active,
                            ['dvui-tab-active']: link.active,
                            [st.swipable]: swipeable
                        }
                    )
                    const key = `tab-${i}`

                    if (link.active) {
                        return <Comp
                            key={key}
                            {...link.attrs}
                            className={className}
                            ref={this.active}
                        >
                            {link.content}
                        </Comp>
                    } else {
                        return <Comp
                            key={key}
                            {...link.attrs}
                            className={className}
                        >
                            {link.content}
                        </Comp>
                    }
                })}
            </HeadingBlock>
        )
    }
}

// Add displayName to preserve the component name on snapshot testing
TabHeading.displayName = 'TabHeading'
